(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pamda-party-builder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('party-bag-builder')) {
  customElements.define('party-bag-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.cards = [...this.querySelectorAll('[data-candy]')];
      this.counts = this.cards.map(() => 0);
      this.form = this.querySelector('.party-form');
      this.bags = this.querySelector('[data-bags]');
      this.date = this.querySelector('input[type=date]');
      const today = new Date();
      today.setMinutes(today.getMinutes() - today.getTimezoneOffset());
      this.date.min = today.toISOString().slice(0,10);
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'fr', {style:'currency',currency:'EUR'});
      this.addEventListener('click', event => {
        const bagButton = event.target.closest('[data-bag-change]');
        if (bagButton && this.contains(bagButton)) {
          const next = Number(this.bags.value) + Number(bagButton.dataset.bagChange);
          this.bags.value = String(Math.min(Number(this.bags.max), Math.max(Number(this.bags.min), next)));
          this.update();
          return;
        }
        const button = event.target.closest('[data-change]');
        if (!button || !this.contains(button)) return;
        const index = this.cards.indexOf(button.closest('[data-candy]'));
        const next = this.counts[index] + Number(button.dataset.change);
        const total = this.counts.reduce((a,b) => a+b,0);
        if (next < 0 || next > Number(this.dataset.perCandy) || total + Number(button.dataset.change) > Number(this.dataset.limit)) return;
        this.counts[index] = next;
        this.update();
      });
      this.addEventListener('change', () => this.update());
      this.bags.addEventListener('input', () => this.update());
      this.form.addEventListener('submit', async event => {
        event.preventDefault();
        this.update();
        if (!this.validSelection() || !this.bags.validity.valid || !this.form.reportValidity() || this.submitting) return;
        this.submitting = true;
        this.querySelector('[data-submit]').disabled = true;
        this.querySelector('[data-submit-error]').hidden = true;
        try {
          const response = await fetch(this.dataset.cartAdd, {method:'POST',body:new FormData(this.form),headers:{Accept:'application/json'}});
          if (!response.ok) throw new Error('Cart add failed');
          const checkoutRoot = window.Shopify?.routes?.root || '/';
          window.location.assign(`${checkoutRoot}checkout`);
        } catch (error) {
          const message = this.querySelector('[data-submit-error]');
          message.hidden = false;
          message.focus({preventScroll:true});
          message.scrollIntoView({behavior:'smooth',block:'start'});
        } finally {
          this.submitting = false;
          this.update();
        }
      });
      this.update();
    }
    validSelection() {
      return this.querySelector('input[type=radio]:checked').value === 'surprise' || this.counts.reduce((a,b)=>a+b,0) === Number(this.dataset.limit);
    }
    update() {
      const surprise = this.querySelector('input[type=radio]:checked').value === 'surprise';
      const total = this.counts.reduce((a,b)=>a+b,0);
      const limit = Number(this.dataset.limit);
      const bagCount = Number(this.bags.value);
      const validBags = Number.isInteger(bagCount) && bagCount >= Number(this.bags.min) && bagCount <= Number(this.bags.max);
      this.querySelector('[data-candies]').hidden = surprise;
      this.querySelector('[data-surprise-info]').hidden = !surprise;
      this.querySelector('[data-piece-count]').textContent = `${surprise ? limit : total} / ${limit}`;
      this.querySelector('[data-progress]').value = surprise ? limit : total;
      this.querySelector('[data-piece-status]').textContent = surprise ? this.dataset.surpriseSummary : total === limit ? this.dataset.complete : this.dataset.remaining.replace('[n]',String(limit-total));
      this.cards.forEach((card,index)=>{
        card.querySelector('[data-candy-count]').textContent = String(this.counts[index]);
        card.querySelector('[data-change="-1"]').disabled = this.counts[index] === 0;
        card.querySelector('[data-change="1"]').disabled = this.counts[index] >= Number(this.dataset.perCandy) || total >= limit;
      });
      const summary = this.querySelector('[data-composition]');
      const lines = this.cards.flatMap((card,index)=> this.counts[index] ? [`${this.counts[index]} × ${card.dataset.name}`] : []);
      summary.replaceChildren();
      if (surprise || !lines.length) summary.textContent = surprise ? this.dataset.surpriseSummary : this.dataset.empty;
      else {
        const list = document.createElement('ul');
        lines.forEach(text=>{const item=document.createElement('li');item.textContent=text;list.append(item);});
        summary.append(list);
      }
      const version = this.querySelector('[data-version]:checked');
      const selectedPrice = Number(version.dataset.price);
      this.querySelector('[data-selected-variant]').value = version.dataset.variantId;
      const formattedTotal = this.money.format(validBags ? bagCount * selectedPrice / 100 : 0);
      this.querySelector('[data-total]').textContent = formattedTotal;
      this.querySelector('[data-bag-change="-1"]').disabled = !Number.isFinite(bagCount) || bagCount <= Number(this.bags.min);
      this.querySelector('[data-bag-change="1"]').disabled = !Number.isFinite(bagCount) || bagCount >= Number(this.bags.max);
      this.querySelector('[data-large-order]').hidden = !Number.isFinite(bagCount) || bagCount < Number(this.bags.max);
      this.querySelector('[data-mode-field]').value = surprise ? this.dataset.modeSurprise : this.dataset.modeCustom;
      this.querySelector('[data-composition-field]').value = surprise ? this.dataset.surpriseSummary : lines.join(' · ');
      this.querySelector('[data-submit]').disabled = !this.validSelection() || !validBags || this.submitting;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
